import { isAuthenticatedGuard, hasPermissionGuard } from '@/modules/auth/router/authGuard';
import appConfig from '@/app.config';

import SystemLayout from '@/modules/system/layouts/SystemLayout.vue';
import ReporteView from '@/modules/reportes/views/ReporteView.vue';
import { REPORTES } from '@/modules/reportes/utils/reportesConfig';

// Una ruta por reporte, todas sobre ReporteView: meta.reporte indica cuál mostrar.
const rutaReporte = (reporte: string) => ({
    path: `/reporte-${ reporte }`,
    name: `reporte-${ reporte }`,
    component: ReporteView,
    beforeEnter: [isAuthenticatedGuard, hasPermissionGuard('reportes')],
    meta: {
        title: appConfig.TITULO_SISTEMA + ' - ' + REPORTES[reporte].titulo,
        titleForm: REPORTES[reporte].titulo,
        reporte,
    },
});

export default {
    name: 'reportes',
    component: SystemLayout,
    children: Object.keys(REPORTES).map(rutaReporte),
};
